import React, { useEffect, useState } from "react";
import TablePrimary from "../../../components/table/TablePrimary";
import { getDate } from "../../../functions/time";
import Badge from "../../../components/Badge";
import PopupCommon from "../../../components/popups/PopupCommon";
import BreadCrumbs from "../../../layout/BreadCrumbs";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import ButtonPrimary from "../../../components/buttons/ButtonPrimary";
import InputText from "../../../components/input/InputText";
import InputSelect from "../../../components/input/InputSelect";
import InputPassword from "../../../components/input/InputPassword";
import InputArray from "../../../components/input/InputArray";
import { createUserWithEmailAndPassword } from "firebase/auth";
import { auth, db } from "../../../config/firebaseConfig";
import { collection, deleteDoc, doc, getDoc, getDocs, setDoc, updateDoc } from "firebase/firestore";
import { HOSTNAME } from "../../../config/constants";
import { useDispatch } from "react-redux";
import { setnotification } from "../../../redux/actions/styles";
import { getFunctions, httpsCallable } from "firebase/functions";
import { emailValidation, passwordValidation } from "../../../functions/validations";
import { setfeedback } from "../../../redux/actions/feedback";
import { ButtonBase, Tooltip } from "@mui/material";
import TooltipPrimary from "../../../components/tooltips/TooltipPrimary";
import SplashScreen from "../../../layout/SplashScreen";
import LockIcon from "@mui/icons-material/Lock";
import DeleteIcon from "@mui/icons-material/Delete";
import EditRoundedIcon from "@mui/icons-material/EditRounded";
import DoNotDisturbAltIcon from "@mui/icons-material/DoNotDisturbAlt";
import RemoveRedEyeRoundedIcon from "@mui/icons-material/RemoveRedEyeRounded";
import PopupConfirmation from "../../../components/popups/PopupConfirmation";

const ManageUsers = () => {
  const dispatch = useDispatch();

  const { outlet, table } = useParams();
  const { restaurantConfig } = useSelector((state) => state.config);

  const [editPopup, seteditPopup] = useState(null);

  const [loading, setloading] = useState(true);

  const [usersList, setusersList] = useState([]);

  const [userName, setuserName] = useState("");
  const [userEmail, setuserEmail] = useState("");
  const [userPassword, setuserPassword] = useState("");
  const [userRole, setuserRole] = useState("");
  const [assignedOutlet, setassignedOutlet] = useState([]);

  const [changePasswordPopup, setchangePasswordPopup] = useState(null);
  const [newUserPassword, setnewUserPassword] = useState("");

  const [deleteUserPopup, setdeleteUserPopup] = useState(null);
  const [userStatusPopup, setuserStatusPopup] = useState(null);

  const headers = [
    {
      name: "User Name",
      ref: "name",
    },
    {
      name: "User Email",
      ref: "email",
    },
    // {
    //   name: "Created At",
    //   ref: "createdAt",
    //   component: (data) => <span>{getDate(data.createdAt)}</span>,
    // },
    {
      name: "Role",
      ref: "role",
      component: (data) => (
        <Badge backgroundColor={data.role === "admin" ? "var(--color-success)" : "var(--color-primary)"}>
          {data.role.charAt(0).toUpperCase() + data.role.slice(1)}
        </Badge>
      ),
    },
    {
      name: "Status",
      ref: "disabled",
      component: (data) => (
        <Badge backgroundColor={!data.disabled ? "var(--color-success)" : "var(--color-danger)"}>
          {data.disabled ? "Disabled" : "Active"}
        </Badge>
      ),
    },
    {
      name: "Outlet Access",
      ref: "outletAccess",
      component: (data) =>
        data.outletAccess.length ? (
          <TooltipPrimary
            text={
              <>
                {data.outletAccess.map((item) => (
                  <p key={item.value}>{item.name}</p>
                ))}
              </>
            }
            align="top"
          >
            {data.outletAccess.length > 1 ? (
              <span>{data.outletAccess[0].name}...</span>
            ) : (
              <span>{data.outletAccess[0].name}</span>
            )}
          </TooltipPrimary>
        ) : null,
    },
    {
      name: "Actions",
      ref: "actions",
      component: (data) => (
        <div className="action-col" style={{ width: "15rem" }}>
          <TooltipPrimary text="Edit" align="top">
            <ButtonBase
              className="table-icon edit"
              onClick={() => {
                seteditPopup("Update");
                setuserName(data.name);
                setuserEmail(data.email);
                setuserRole(data.role);
                setassignedOutlet(data.outletAccess);
              }}
            >
              <EditRoundedIcon />
            </ButtonBase>
          </TooltipPrimary>
          {!data.disabled ? (
            <TooltipPrimary text="Disable" align="top">
              <ButtonBase
                className="table-icon disable"
                onClick={() => {
                  setuserStatusPopup(data);
                }}
              >
                <DoNotDisturbAltIcon />
              </ButtonBase>
            </TooltipPrimary>
          ) : (
            <TooltipPrimary text="Enable" align="top">
              <ButtonBase
                className="table-icon enable"
                onClick={() => {
                  setuserStatusPopup(data);
                }}
              >
                <RemoveRedEyeRoundedIcon />
              </ButtonBase>
            </TooltipPrimary>
          )}
          <TooltipPrimary text="Delete" align="top">
            <ButtonBase
              className="table-icon delete"
              onClick={() => {
                setdeleteUserPopup(data);
              }}
            >
              <DeleteIcon />
            </ButtonBase>
          </TooltipPrimary>
          <TooltipPrimary text="Change Password" align="top">
            <ButtonBase
              className="table-icon tertiary"
              onClick={() => {
                setchangePasswordPopup(data);
              }}
            >
              <LockIcon />
            </ButtonBase>
          </TooltipPrimary>
        </div>
      ),
    },
  ];
  function clearInput() {
    setuserName("");
    setuserEmail("");
    setuserPassword("");
    setuserRole("");
    setassignedOutlet([]);
    setnewUserPassword("");
  }

  async function getUsersData() {
    const userAccountsRef = doc(db, "userAccounts", HOSTNAME);
    const userIdRef = collection(userAccountsRef, "accounts");

    const docSnapshot = await getDocs(userIdRef);

    let usersArray = [];

    docSnapshot.forEach((doc) => {
      const data = doc.data();
      usersArray.push(data);
    });

    setusersList(usersArray);
    setloading(false);
  }

  useEffect(() => {
    getUsersData();
  }, []);

  async function createUser() {
    if (!userName || !emailValidation(userEmail) || !passwordValidation(userPassword) || !userRole) {
      dispatch(setnotification({ visible: true, text: "Please enter valid credentials.", type: "info" }));
      return;
    }

    try {
      const user = auth.currentUser;

      const idTokenResult = await user.getIdTokenResult();
      const isAdmin = idTokenResult.claims.admin;

      if (isAdmin) {
        dispatch(setfeedback({ loading: true, status: "", message: "Creating User..." }));

        const userAccountsRef = doc(db, "userAccounts", HOSTNAME);
        const userIdRef = doc(userAccountsRef, "accounts", userEmail);
        const dlintIdRef = doc(userAccountsRef, "clients", userEmail);

        const userDocSnapshot = await getDoc(userIdRef);
        const clientDocSnapshot = await getDoc(dlintIdRef);

        if (userDocSnapshot.exists() || clientDocSnapshot.exists()) {
          dispatch(setfeedback({ loading: true, status: "f", message: "User already exists..." }));

          setTimeout(() => {
            dispatch(setfeedback({ loading: false, status: "", message: "" }));
          }, 2000);

          return;
        }

        const functions = getFunctions();

        const createUserCloud = httpsCallable(functions, "createUser");

        const user = await createUserCloud({
          email: userEmail,
          password: userPassword,
          displayName: userName,
          role: userRole,
        });

        await setDoc(userIdRef, {
          id: user.data.uid,
          name: userName,
          email: userEmail,
          role: userRole,
          createdAt: new Date(),
          updatedAt: new Date(),
          outletAccess: assignedOutlet,
          domain: HOSTNAME,
          disabled: false,
        });

        dispatch(setfeedback({ loading: true, status: "s", message: "User Created Successfully..." }));

        setTimeout(() => {
          dispatch(setfeedback({ loading: false, status: "", message: "" }));
        }, 2000);

        seteditPopup(null);
        clearInput();
        getUsersData();
      }
    } catch (error) {
      console.error("Error signing up:", error);
    }
  }

  async function updateUser() {
    if (!userName || !userRole) {
      dispatch(setnotification({ visible: true, text: "Please enter valid credentials.", type: "info" }));
      return;
    }

    try {
      const user = auth.currentUser;
      const idTokenResult = await user.getIdTokenResult();
      const isAdmin = idTokenResult.claims.admin;

      if (isAdmin) {
        dispatch(setfeedback({ loading: true, status: "", message: "Updating User..." }));

        const userAccountsRef = doc(db, "userAccounts", HOSTNAME);
        const userIdRef = doc(userAccountsRef, "accounts", userEmail);

        const userDocSnapshot = await getDoc(userIdRef);

        if (userDocSnapshot.exists()) {
          const data = userDocSnapshot.data();

          await updateDoc(userIdRef, {
            name: userName,
            role: userRole,
            updatedAt: new Date(),
            outletAccess: assignedOutlet,
          });

          const functions = getFunctions();
          const setAdmin = httpsCallable(functions, "setAdminAccess");

          if (userRole === "admin") {
            await setAdmin({ uid: data.id, isAdmin: true });
          } else {
            await setAdmin({ uid: data.id, isAdmin: false });
          }

          dispatch(setfeedback({ loading: true, status: "s", message: "User Updated Successfully..." }));

          setTimeout(() => {
            dispatch(setfeedback({ loading: false, status: "", message: "" }));
          }, 2000);

          seteditPopup(null);
          clearInput();
          getUsersData();
        }
      }
    } catch (error) {
      console.error("Error signing up:", error);
    }
  }

  async function deleteUser() {
    try {
      const user = auth.currentUser;
      const idTokenResult = await user.getIdTokenResult();
      const isAdmin = idTokenResult.claims.admin;

      if (isAdmin) {
        dispatch(setfeedback({ loading: true, status: "", message: "Deleting User..." }));

        const userAccountsRef = doc(db, "userAccounts", HOSTNAME);
        const userIdRef = doc(userAccountsRef, "accounts", deleteUserPopup.email);

        await deleteDoc(userIdRef);

        const functions = getFunctions();
        const deleteUser = httpsCallable(functions, "deleteUser");

        await deleteUser({ uid: deleteUserPopup.id });

        dispatch(setfeedback({ loading: true, status: "s", message: "User Deleted Successfully..." }));

        setTimeout(() => {
          dispatch(setfeedback({ loading: false, status: "", message: "" }));
        }, 2000);

        seteditPopup(null);
        clearInput();
        getUsersData();
      }
    } catch (error) {
      console.error("Error signing up:", error);
    }
  }

  async function changeUserPassword() {
    try {
      const user = auth.currentUser;
      const idTokenResult = await user.getIdTokenResult();
      const isAdmin = idTokenResult.claims.admin;

      if (isAdmin) {
        dispatch(setfeedback({ loading: true, status: "", message: "Changing User Password..." }));

        const functions = getFunctions();
        const changeUserPassword = httpsCallable(functions, "changeUserPassword");

        await changeUserPassword({ uid: changePasswordPopup.id, newPassword: newUserPassword });

        dispatch(setfeedback({ loading: true, status: "s", message: "User Password Changed Successfully..." }));

        setTimeout(() => {
          dispatch(setfeedback({ loading: false, status: "", message: "" }));
        }, 2000);

        setchangePasswordPopup(null);
        clearInput();
        getUsersData();
      }
    } catch (error) {
      console.error("Error signing up:", error);
    }
  }

  async function updateUserStatus() {
    try {
      const user = auth.currentUser;
      const idTokenResult = await user.getIdTokenResult();
      const isAdmin = idTokenResult.claims.admin;

      if (isAdmin) {
        dispatch(setfeedback({ loading: true, status: "", message: "Updating User Status..." }));

        const userAccountsRef = doc(db, "userAccounts", HOSTNAME);
        const userIdRef = doc(userAccountsRef, "accounts", userStatusPopup.email);

        const userDocSnapshot = await getDoc(userIdRef);

        if (userDocSnapshot.exists()) {
          const data = userDocSnapshot.data();

          await updateDoc(userIdRef, {
            disabled: !userStatusPopup.disabled,
          });

          const functions = getFunctions();
          const setUserStatus = httpsCallable(functions, "setUserStatus");

          await setUserStatus({ uid: data.id, disable: !userStatusPopup.disabled });

          dispatch(setfeedback({ loading: true, status: "s", message: "User Status Updated Successfully..." }));

          setTimeout(() => {
            dispatch(setfeedback({ loading: false, status: "", message: "" }));
          }, 2000);

          setuserStatusPopup(null);
          clearInput();
          getUsersData();
        }
      }
    } catch (error) {
      console.error("Error signing up:", error);
    }
  }

  if (loading) {
    return <SplashScreen loadingScreen />;
  }

  return (
    <div className="manage-users">
      <BreadCrumbs
        data={[
          {
            name: outlet ? `${outlet}` : restaurantConfig.restaurantName,
            link: table ? `/${outlet}/${table}` : outlet ? `/${outlet}` : "/",
          },
          { name: "Settings", link: table ? (outlet ? `/manage/${outlet}/${table}` : `/manage/${outlet}`) : "/manage" },
          { name: "Manage Users" },
        ]}
      />

      <div className="flex-je-ac mb-2">
        <ButtonPrimary text="Add User" size="md" onClick={() => seteditPopup("Create")} />
      </div>

      <TablePrimary
        headers={headers}
        data={usersList}
        tableId="tableCompletedOrders"
        disableDrag
        disableSave
        disableActions
      />
      {editPopup && (
        <PopupCommon
          size="sm"
          onClickFalse={() => {
            seteditPopup(null);
            clearInput();
          }}
          isVisible={editPopup}
        >
          {editPopup === "Create" ? <h3 className="mb-3">Create User</h3> : <h3 className="mb-3">{userEmail}</h3>}

          <InputText
            size="sm"
            label="User Name"
            placeholder="Enter User Name"
            className="mb-2"
            value={userName}
            onChange={(e) => setuserName(e.target.value)}
            validation="ne"
          />
          {editPopup === "Create" && (
            <InputText
              size="sm"
              label="User E-mail"
              placeholder="Enter User E-mail"
              className="mb-2"
              value={userEmail}
              onChange={(e) => setuserEmail(e.target.value)}
              validation="email"
            />
          )}
          {editPopup === "Create" && (
            <>
              <InputPassword
                size="sm"
                label="User Password"
                placeholder="Enter User Password"
                className="mb-1"
                value={userPassword}
                onChange={(e) => setuserPassword(e.target.value)}
              />
              <p className="helper mb-2">
                Password should be minimum 6 characters with minimum 1 capital letter, 1 number and 1 special character.
              </p>
            </>
          )}
          <InputSelect
            size="sm"
            label="Select Role"
            placeholder="Select Role"
            options={[{ name: "admin" }, { name: "manager" }]}
            itemKey="name"
            className={!userRole || userRole === "admin" ? "mb-3" : "mb-3"}
            value={userRole}
            onClickItem={(data) => setuserRole(data.name)}
            validation="ne"
          />

          {userRole && userRole !== "admin" && (
            <InputArray
              className="mb-3"
              value=""
              setvalue={() => {}}
              selectedArray={assignedOutlet}
              setselectedArray={setassignedOutlet}
              label="Assign Outlets Access"
              options={restaurantConfig.outlets.map((item) => ({ name: item.outletName, value: item.outletId }))}
              // onChange={(e) => {
              //   filters.length < 5 && setfilterText(e.target.value);
              // }}
              onClickList={(item) => {
                assignedOutlet.length < 5 && setassignedOutlet([...assignedOutlet, item]);
              }}
            />
          )}
          <ButtonPrimary
            text={`${editPopup} User`}
            size="sm"
            onClick={editPopup === "Create" ? createUser : updateUser}
          />
        </PopupCommon>
      )}

      {changePasswordPopup && (
        <PopupCommon
          size="sm"
          onClickFalse={() => {
            setchangePasswordPopup(null);
            clearInput();
          }}
          isVisible={changePasswordPopup}
        >
          <h3 className="mb-3">{changePasswordPopup.email}</h3>
          <InputPassword
            size="sm"
            label="New Password"
            placeholder="Enter New Password"
            className="mb-1"
            value={newUserPassword}
            onChange={(e) => setnewUserPassword(e.target.value)}
          />
          <p className="helper mb-3">
            Password should be minimum 6 characters with minimum 1 capital letter, 1 number and 1 special character.
          </p>
          <ButtonPrimary text={`Change Password`} size="sm" onClick={changeUserPassword} />
        </PopupCommon>
      )}

      {deleteUserPopup && (
        <PopupConfirmation
          message={`Are you sure you want to delete user ${deleteUserPopup.email}?`}
          onClickTrue={deleteUser}
          trueText="Delete"
          onClickFalse={() => setdeleteUserPopup(null)}
          falseText="Cancel"
          isVisible={deleteUserPopup}
          variant="delete"
        />
      )}
      {userStatusPopup && (
        <PopupConfirmation
          message={`Are you sure you want to ${userStatusPopup.disabled ? "enable" : "disable"} user ${
            userStatusPopup.email
          }?`}
          onClickTrue={updateUserStatus}
          trueText={userStatusPopup.disabled ? "Enable User" : "Disable User"}
          onClickFalse={() => setuserStatusPopup(null)}
          falseText="Cancel"
          isVisible={userStatusPopup}
          // variant="delete"
        />
      )}
    </div>
  );
};

export default ManageUsers;
